import React, { useContext, useEffect, useState } from "react";
import img1 from "../assets/images/img1.svg";
import img2 from "../assets/images/img2.svg";
import img3 from "../assets/images/img3.svg";
import img4 from "../assets/images/img4.svg";
import axios from "axios";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const MakePayment = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const t = translations[language];
  const [iconModal, setIconModal] = useState(false);
  const [creditModal, setCreditModal] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const [selectedDebt, setSelectedDebt] = useState();

  const [amount, setAmount] = useState("");
  const [customerCode, setCustomerCode] = useState();
  const [customerFin, setCustomerFin] = useState();
  const [contractName, setContractName] = useState();

  const [error, setError] = useState("");

  const [inputs, setInputs] = useState({
    fin: "",
    customerCode: "",
  });

  const [errors, setErrors] = useState({
    fin: "",
    customerCode: "",
  });

  const validate = () => {
    let valid = true;
    let newErrors = { fin: "", customerCode: "" };

    // FİN kod validation (7 simvol, yalnız hərf və rəqəm)
    if (!inputs.fin) {
      newErrors.fin = "İdentifikasiya nömrəsini  kod daxil edin";
      valid = false;
    } else if (!/^[A-Z0-9]{7}$/i.test(inputs.fin)) {
      newErrors.fin = "FİN kod 7 simvol olmalıdır (A-Z və 0-9)";
      valid = false;
    }

    // Müştəri kodu validation (yalnız rəqəm, 6 simvol misal üçün)
    if (!inputs.customerCode) {
      newErrors.customerCode = "Müştəri kodu daxil edin";
      valid = false;
    } else if (!/^\d{9}$/.test(inputs.customerCode)) {
      newErrors.customerCode = "Müştəri kodu 9 rəqəmdən ibarət olmalıdır";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Input dəyişəndə erroru təmizlə
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = new URLSearchParams();
    params.append("FIN", inputs.fin);
    params.append("CustomerCode", inputs.customerCode);

    setLoading(true);

    try {
      const response = await axios.post(
        "https://myshops.az/test/mk.php?action=checkDebt",
        params,
        {
          headers: {
            Authorization: "Basic MWNfV2ViU2Vydml0b3I6MXdARXI0RSMwOX17",
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept-Language": "*",
          },
        }
      );
     console.log("budur",response);
     
      setResult(response.data);
    } catch (error) {
      console.error("Xəta:", error);
      alert("Sorğu zamanı xəta baş verdi");
    } finally {
      setLoading(false);
    }
  };

  const handleIconModal = (e) => {
    e.preventDefault();
    setIconModal((prev) => !prev);
  };

  const handleCreditModal = (e) => {
    e.preventDefault();
    setCreditModal((prev) => !prev);
  };

  const rawData = result && result.customerName;
  // Məsələn: "ƏHMƏDOV ELŞƏN MÜŞFİQ OĞLU 994-70-272-75-73"

  // Telefon regex-i
  const phoneRegex = /994-\d{2}-\d{3}-\d{2}-\d{2}/;

  // Nömrəni tapırıq
  const phone = (rawData && rawData.match(phoneRegex)?.[0]) || "";

  // Ad hissəsini tapırıq (nömrəni çıxarırıq)
  const name = rawData && rawData.replace(phoneRegex, "").trim();

  const handleSelectDebt = (e) => {
    const selectedObject = JSON.parse(e.target.value); // JSON-u parse edirik

    setSelectedDebt(selectedObject.MonthDebt);
    setCustomerCode(selectedObject.CustomerCode);
    setContractName(selectedObject.ContractNumber);
    setCustomerFin(selectedObject.CustomerFIN);

    setAmount(""); // yeni seçimdə input sıfırlansın
    setError(""); // error təmizlənir
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setAmount("");
      setError("");
      return;
    }

    const numericValue = Number(value);

    if (numericValue >= selectedDebt) {
      setAmount(numericValue);
      setError(""); // Xəta yox
    } else {
      setAmount(value); // Yazılan dəyəri saxlayırıq (əks halda silinirdi)
      setError(`Minimum ödəniş ${selectedDebt} ₼-dir`);
    }
  };

  const handleMonthDebt = (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (error) {
       return ;
    }
    formData.append("customer_name",result && result.customerName)
    formData.append("total_debt",result && result.totalDebt)
    formData.append("customer_code", customerCode);
    formData.append("customer_FIN", customerFin);
    formData.append("contract_number", contractName);
    formData.append("amount", amount);
    formData.append("contract_amount", amount);
    axios
      .post("https://myshops.az/test/mk.php?action=createOrder", formData)
      .then((res) => {
        if (res.data && res.data.hppUrl) {
          window.location.href = res.data.hppUrl; // avtomatik yönləndirir
        }
      })
      .catch((err) => {
        console.log("XETA :", err);
      });
  };

  useEffect(() => {
    if (result?.contracts && result.contracts.length > 0) {
      const firstContract = result.contracts[0];

      // handleSelectDebt funksiyasındakı state-ləri avtomatik doldururuq
      setSelectedDebt(firstContract.MonthDebt);
      setCustomerCode(firstContract.CustomerCode);
      setContractName(firstContract.ContractNumber);
      setCustomerFin(firstContract.CustomerFIN);
      setAmount(firstContract.MonthDebt); // inputu da avtomatik doldururuq
      setError(""); // error təmizlənir
    }
  }, [result?.contracts]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // URL-dəki bütün query parametrləri götürürük
    const params = new URLSearchParams(location.search);
    const status = params.get("STATUS") || params.get("Status") || params.get("status");
   

    if (!status) return; // STATUS yoxdursa heç nə etmə

    // STATUS-a görə yönləndirmə
    if (status === "Cancelled") {
      navigate("/payment-cancelled");
    } else if (status === "FullPaid") {
      navigate("/payment-success");
    }
  }, [location.search, navigate]);


console.log(result);
  return (
    <>
      <section className="makepayment">
        <div className={`makeContent ${result?.success ? "d-none" : "d-block"}`}>
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <button id="backBtn">
              <i
                className="fa-solid fa-reply me-2"
                style={{ fontSize: "small" }}
              ></i>{" "}
              {t.back}
            </button>
          </NavLink>

          <form onSubmit={handleSubmit}>
            <h5 className="text-center  mt-4">{t.paymentTitle}</h5>
            {result && result.success == false && (
              <p
                className={`text-center text-danger ${
                  result.success == false ? "d-block" : "d-none"
                }`}
              >
                {result.message}
              </p>
            )}
            {/* <span style={{ fontSize: "15px" }}>{t.fin}</span>
            <div className="input-wrapper mt-2">
              <input
                type="text"
                id="identifikasiya"
                value={inputs.fin}
                name="fin"
                placeholder={t.fin}
                onChange={handleChange}
              />
              <span
                className="input-icon"
                style={{ cursor: "pointer", pointerEvents: "auto" }}
              >
                <i
                  className="fa-solid fa-circle-info"
                  onClick={handleIconModal}
                ></i>
              </span>
            </div> */}
            {errors.fin && (
              <p style={{ color: "red", fontSize: "14px" }}>{errors.fin}</p>
            )}

            <br />
            <span style={{ fontSize: "15px" }}>{t.customerCode}</span>
            <div className="input-wrapper mt-2">
              <input
                type="text"
                id="customerCode"
                name="customerCode"
                value={inputs.customerCode}
                placeholder={t.customerCode}
                onChange={handleChange}
              />
            </div>
            {errors.customerCode && (
              <p style={{ color: "red", fontSize: "14px" }}>
                {errors.customerCode}
              </p>
            )}

            <div className="my-3">
              <a href="" onClick={handleCreditModal}>
                {t.creditTitle} 
              </a>
            </div>

            <div>
              <button className="my-3 rounded" type="submit">
                {t.signIn}
              </button>
            </div>
          </form>
        </div>

        {/* Modal */}
        {iconModal && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              backdropFilter: "blur(5px)",
            }}
          >
            <div
              className="modal-content"
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "600px",
                width: "100%",
                position: "relative",
              }}
            >
              <button
                onClick={handleIconModal}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  border: "none",
                  background: "transparent",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>
              <div className="d-flex justify-content-between align-items-center">
                <h4>{t.fin}</h4>
                <i className="fa-solid fa-xmark"></i>
              </div>
              <div className="container">
                <span dangerouslySetInnerHTML={{ __html: t.finDesc }} />
                <div className="row mt-1 g-3">
                  {[img1, img2, img3, img4].map((item, index) => {
                    return (
                      <div className="col-6" key={index}>
                        <img src={item} alt="" className="img-fluid" />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Kredit Modal */}
        {creditModal && (
          <div
            className="modal-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              backdropFilter: "blur(5px)",
            }}
          >
            <div
              className="modal-content"
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "600px",
                width: "100%",
                position: "relative",
              }}
            >
              <button
                onClick={handleCreditModal}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  border: "none",
                  background: "transparent",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>
              <div className="d-flex justify-content-between align-items-center">
                <h4>{t.myCarsCredit}</h4>
                <i className="fa-solid fa-xmark"></i>
              </div>
              <div className="container">
                <div className="row mt-1 g-3">
                  <div className="col-12">
                    <ul
                      dangerouslySetInnerHTML={{ __html: t.myCarsCreditDesc }}
                    ></ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
   {result?.success && (
          <div className="makeContent">
            <NavLink to="/" style={{ textDecoration: "none" }}>
              <button id="backBtn">
                <i
                  className="fa-solid fa-reply me-2"
                  style={{ fontSize: "small" }}
                ></i>{" "}
                {t.back}
              </button>
            </NavLink>

            <form onSubmit={handleMonthDebt}>
              <h5 className="text-center my-4">{t.paymentResult}</h5>
              <div className="my-4 d-flex justify-content-between align-items-center mt-5">
                <h6 className="d-flex align-items-center">
                  {" "}
                  <i
                    className="fa-solid fa-user me-1"
                    style={{ fontSize: "small", color: "#01999C" }}
                  ></i>{" "}
                  {t.soyadad}
                </h6>
                <h6>{name && name}</h6>
              </div>
              <div className="my-4 d-flex justify-content-between align-items-center">
                <h6 className="d-flex align-items-center">
                  <i
                    className="fa-solid fa-phone me-1"
                    style={{ fontSize: "small", color: "#01999C" }}
                  ></i>{" "}
                  {t.mobilnomre}
                </h6>
                <h6>{phone && phone}</h6>
              </div>
              {/* <div className="my-4 d-flex justify-content-between align-items-center">
                <h6 className="d-flex align-items-center">
                  <i
                    className="fa-solid fa-money-check-dollar me-1"
                    style={{ fontSize: "small", color: "#01999C" }}
                  ></i>{" "}
                  {t.umumiborc}
                </h6>
                <h6
                  style={{
                    padding: "10px 20px",
                    background: "red",
                    borderRadius: "20px",
                    color: "#fff",
                  }}
                >
                  {result.totalDebt} ₼
                </h6>
              </div> */}
              <span style={{ fontSize: "15px" }}>{t.odenisCredit}</span>
              <div className="input-wrapper mt-2 mb-4">
                <select name="" id="" onChange={handleSelectDebt}>
                  {result &&
                    result.contracts &&
                    result.contracts.map((i) => {
                      return (
                        <option
                          value={JSON.stringify({
                            MonthDebt: i.MonthDebt,
                            ContractNumber: i.ContractNumber,
                            CustomerCode: i.CustomerCode,
                            CustomerFIN: i.CustomerFIN,
                            CustomerName: i.CustomerName,
                          })}
                        >
                          {i.MonthDebt} ₼ - {i.ContractNumber} -{" "}
                          {t.customerCode} : {i.CustomerCode}{" "}
                        </option>
                      );
                    })}
                </select>
              </div>
              <span style={{ fontSize: "15px" }}>{t.odenilecekMebleg}</span>
              <div className="input-wrapper mt-2">
                <input
                  type="number"
                  value={amount}
                  style={{ border: `${error ? "1px solid red" : ""}` }}
                  onChange={handleInputChange}
                  placeholder={t.odenisPlaceholder}
                />
                {error && (
                  <p style={{ color: "red", fontSize: "14px" }}>{error}</p>
                )}
              </div>
              <div>
                <button className="my-3 rounded" type="submit">
                 {t.odenisEt}
                </button>
              </div>
            </form>
          </div>
        )}
     
      </section>
    </>
  );
};

export default MakePayment;
